import React, {
  createRef,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";
import * as RB from "react-bootstrap";
import * as utils from "../../Utils/comman";
import { useSelector } from "react-redux";
import noImage from "../../assets/images/no_image.jpg";
import { Cancel, Verified } from "@mui/icons-material";
import { fetchUserProfile } from "../../reducers/userProfileSlice";
import "../../assets/scss/styles/QuotationComponent.css";
import moment from "moment";

function View1(props) {
  const { rowData } = props;
  const userProfile = useSelector((state) => state?.userProfile?.userProfile);
  console.log("Here view rowData props would be ", rowData);

  const handleBackClick = () => {
    const propdata = {
      mode: "list",
    };
    props.onChange(propdata);
  };

  function InfoItem({ label, value }) {
    return (
      <RB.Col md={3}>
        <span className="text-uppercase fw-bold small text-body-secondary mr-2">
          {label}
        </span>
        <p className="fw-medium text-sm fw-semibold mb-0">{value}</p>
      </RB.Col>
    );
  }

  const renderProductDetails = (product) => {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: 20,
        }}
      >
        <div style={{ flex: 1 }}>
          <p>
            <span
              style={{
                fontSize: 21,
                // fontFamily: "Gadugi-Bold",
                color: "#FFC000",
              }}
            >
              {product.product_name}
            </span>
            <br />
            <span
              style={{
                fontSize: 14,
                //fontFamily: "Calibri"
              }}
            >
              {product.description}
            </span>
            <br />
            <strong
              style={{
                fontSize: 15,
                //fontFamily: "Calibri-Bold"
              }}
            >
              PROJECT PACKING:
            </strong>{" "}
            <span
              style={{
                fontSize: 15,
                // fontFamily: "Calibri"
              }}
            >
              {product.qty}
            </span>
            <br />
            <strong
              style={{
                fontSize: 15,
                //fontFamily: "Calibri-Bold"
              }}
            >
              MRP:
            </strong>{" "}
            <span
              style={{
                fontSize: 15,
                //fontFamily: "Calibri"
              }}
            >
              {product.currency} {product.sales_price}/-
            </span>
            <br />
            <strong
              style={{
                fontSize: 15,
                // fontFamily: "Calibri-Bold"
              }}
            >
              DISCOUNTED PRICE:
            </strong>{" "}
            <span
              style={{
                fontSize: 15,
                //fontFamily: "Calibri"
              }}
            >
              {product.discount_price}
            </span>
          </p>
        </div>
        {product.image && (
          <div style={{ flexShrink: 0, marginLeft: 20 }}>
            <img
              src={product.image}
              alt={product.product_name}
              style={{ maxWidth: 150, maxHeight: 150, objectFit: "contain" }}
            />
          </div>
        )}
      </div>
    );
  };

  const formatTermsAndConditions = (terms) => {
    return terms
      .replace(/<p>/g, '<span style="display: block; margin: 0; padding: 0;">')
      .replace(/<\/p>/g, "</span>");
  };

  const handleDownload = (row) => {
    window.open(row.document_link, "_blank");
  };

  const isValidTermsCondition = (terms) => {
    const tempDiv = document.createElement("div");
    console.log("TempDiv", tempDiv);
    tempDiv.innerHTML = terms;
    console.log((tempDiv.innerHTML = terms));
    return tempDiv.textContent.trim().length > 0;
  };

  return (
    <div className="section-body">
      <RB.Card className="card shadow">
        <RB.Card.Header className="border-0">
          <h4></h4>
          <div className="card-header-action">
            <RB.Button className="btn btn-light" onClick={handleBackClick}>
              Back
            </RB.Button>

            <RB.Button
              className="btn btn-outline-dark ms-2"
              onClick={() => handleDownload(rowData)}
            >
              Download PDF
            </RB.Button>
          </div>
        </RB.Card.Header>
        <RB.Card.Body>
          <div
            style={{
              padding: "20px",
              width: "100%",
              maxWidth: "935px",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div style={{ flex: 1 }}>
                <p style={{ marginBottom: "20px" }}>
                  <span
                    style={{
                      fontSize: "15px",
                      // fontFamily: "Calibri"
                    }}
                  >
                    To,
                  </span>
                  <br />
                  <span
                    style={{
                      fontSize: "17px",
                      // fontFamily: "Calibri-Bold",
                      fontWeight: "bold",
                    }}
                  >
                    {rowData?.firstName} {rowData?.lastName}
                  </span>
                  <br />
                  <span
                    style={{
                      fontSize: "17px",
                      // fontFamily: "Calibri-Bold",
                      fontWeight: "bold",
                    }}
                  >
                    {rowData?.companyName}
                  </span>
                  <br />
                  <span
                    style={{
                      fontSize: "17px",
                      // fontFamily: "Calibri-Bold",
                      fontWeight: "bold",
                    }}
                  >
                    {rowData?.address}
                  </span>
                </p>
              </div>
              <div style={{ display: "flex" }}>
                <strong style={{ marginRight: "10px" }}>Date:</strong>
                <strong>
                  {moment(rowData?.createdAt).format("DD-MM-yyyy")}
                </strong>
              </div>
            </div>
            <p
              style={{
                marginBottom: "20px",
                fontSize: "14px",
                // fontFamily: "Calibri",
              }}
            >
              SUB: QUOTATION OF{" "}
              {rowData.distributorName === ""
                ? "VURA BAU-CHEMIE LLP PRODUCTS"
                : rowData.distributorName}
            </p>
            <p
              style={{
                marginBottom: "20px",
                fontSize: "14px",
                //   fontFamily: "Calibri",
              }}
            >
              Dear Sir,
              <br />
              First of all, thank you so much for your kind approach and
              considering us for the requirement. As you have shown detailed
              interest in the VURA’s range of solutions, we are very pleased to
              provide below details along with most competitive offer in current
              market.
            </p>
            <p
              style={{
                marginBottom: "20px",
                fontSize: "14px",
                // fontFamily: "Calibri",
                fontWeight: "bold",
              }}
            >
              PROPOSED PRODUCT & DESCRIPTION:
            </p>
            {rowData?.products &&
              rowData?.products.map((product) => (
                <div key={product.name}>{renderProductDetails(product)}</div>
              ))}
            {rowData?.terms_condition &&
              isValidTermsCondition(rowData?.terms_condition) && (
                <>
                  <div
                    style={{
                      marginBottom: "10px",
                      marginTop: "20px",
                      fontSize: "14px",
                      //  fontFamily: "Calibri",
                      fontWeight: "bold",
                    }}
                  >
                    TERMS & CONDITIONS:
                  </div>
                  <div
                    style={{ margin: "0", padding: "0" }}
                    dangerouslySetInnerHTML={{
                      __html: formatTermsAndConditions(
                        rowData?.terms_condition
                      ),
                    }}
                  />
                </>
              )}
          </div>
          <div
            style={{
              marginLeft: "20px",
              fontSize: "15px",
              //  fontFamily: "Calibri",
            }}
          >
            <p style={{ margin: "0" }}>
              We look forward to your valued order and assure you of our best
              services always.
            </p>
          </div>
          <div
            style={{
              marginTop: "20px",
              marginLeft: "20px",
              fontSize: "14px",
              // fontFamily: "Calibri",
            }}
          >
            <p style={{ margin: "0" }}>
              <strong>Thank You,</strong>
            </p>
            <p style={{ margin: "0" }}>Yours sincerely,</p>
            <p style={{ margin: "0" }}>For VURA BAU-CHEMIE LLP.</p>
            <p style={{ margin: "0" }}>
              {userProfile?.firstName + " " + userProfile?.lastName}
            </p>
            <p style={{ margin: "0" }}>{userProfile?.user_role[0]?.roleName}</p>

            {userProfile?.mobileNo && (
              <p style={{ margin: "0" }}>{"+91 " + userProfile?.mobileNo}</p>
            )}
          </div>
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default View1;
